import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Batch, TemplateType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient, request } from '@utils';

interface HookProps {
  batch: Batch;
}

export const useSyncBatchWithCustoms = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batch }: HookProps) => {
      const syncWithCustoms = async () => {
        const result = await apiClient.idms.customsSync.mutation({ params: { batchId: batch._id } });
        if (result.status !== 200) {
          throw result.body;
        }
      };

      if (batch.templateType === TemplateType.HIGH_VALUE_H1) {
        // temp: don't wait for the external notifications to be pulled
        // issue with xcomm FTP server
        Promise.allSettled([syncWithCustoms()]);
      } else {
        await syncWithCustoms();
      }

      const result = await apiClient.batchesWorkflow.recountStatistics.mutation({ params: { id: batch._id } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Batch is added to syncing queue.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error syncing the batch!');
    },
  });
};
